import { createContext } from 'react';

type InterpolationValue = string | number;

export type TranslationMap = Record<string, unknown>;

export interface I18nContextValue {
  locale: string;
  t: (key: string, params?: Record<string, InterpolationValue>) => string;
  get: <T>(key: string, fallback?: T) => T;
}

export const I18nContext = createContext<I18nContextValue | null>(null);
